/**
* Results Dual Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Results Dual Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'results-dual-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.results-dual-marquee__top' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          focus: 'center',
          arrows: false,
          direction: 'rtl',
          pagination: false,
          gap: '1.25rem',
          fixedWidth: `353px`,
          autoScroll: {
            speed: 0.75,
          },
          breakpoints: {
            768: {
              fixedWidth: `300px`,
            },
          },
        } );

        slider.mount( {AutoScroll} );
      } );
      $( '.results-dual-marquee__bottom' ).each( function( index, element ) {
        const slider = new Splide( $( element )[0], {
          type: 'loop',
          focus: 'center',
          arrows: false,
          direction: 'ltl',
          pagination: false,
          gap: '1.25rem',
          fixedWidth: `353px`,
          autoScroll: {
            speed: 0.75,
          },
          breakpoints: {
            768: {
              fixedWidth: `300px`,
            },
          },
        } );

        slider.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'results-dual-marquee', COMPONENT );
} )( app );
